import create from "zustand";

interface ScreenshareState {
	screenshareStudentUsernames: Set<string>;
}

/**
 * Note: This store is reset every time the teacher navigates to a new classroom.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const useScreenshareStore = create<ScreenshareState>((_get, _set) => ({
	screenshareStudentUsernames: new Set<string>(),
}));
